import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-soft-serve-machines',
  templateUrl: './soft-serve-machines.component.html',
  styleUrls: ['./soft-serve-machines.component.scss']
})
export class SoftServeMachinesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/soft-serve-machines/soft-serve-machines.component.ts